import scDefinitons from '../../../common/config/SelectionCriteriaDefinitions';

// eslint-disable-next-line import/prefer-default-export
export const wizardRoutes = (reportName) => {
  const buildWizardLink = wizardPage => `/report-wizard/${reportName}/${wizardPage}`;
  const links = {
    generateReport: buildWizardLink('report'),
  };

  // Prepare selecion criteria wizard links by using sc definitons
  Object.keys(scDefinitons).forEach((sc) => {
    links[scDefinitons[sc].routeName] = buildWizardLink(scDefinitons[sc].routePath);
  });

  return (links);
};
